import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalUpdateSpaceLogo: ExperimentalMutations['experimentalUpdateSpaceLogo'] = (
	_,
	{ spaceKey, spaceName, logoDataURI },
	{ network },
) =>
	fetchJSON(network, `/wiki/rest/ia/1.0/space/setLogo`, {
		method: 'POST',
		body: JSON.stringify({ spaceKey, spaceName, logoDataURI }),
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).then(({ name, logoDownloadPath }) => ({
		key: spaceKey,
		name,
		iconPath: logoDownloadPath,
	}));
